import * as React from "react";
import "./styles/BundleComponent.scss";
import {Bundle, CurrencyDefinition, Settings, UserInfo} from "../http/protocol";
import Button from "./Button";
import {t} from "../i18n";
import CurrencyFormatter from "../utils/CurrencyFormatter";
import Big from "big.js";
import FloatingTitle from "./FloatingTitle";


export enum Category {
    AVATAR = "AVATAR",
    TICKET = "TICKET",
    INVENTORY = "INVENTORY"
}

interface Props {
    bundle: Bundle;
    user: UserInfo;
    onClick: (id: number) => void;
}


const BundleComponent: React.FC<Props> = ({bundle, user, onClick}) => {

    let currencyDefPrice;
    let price = "N/A";
    let awardFunds2Amount = "N/A";
    let awardFunds2CurrencyName = "N/A";
    let currencyDefAwardFunds1: CurrencyDefinition | undefined;
    let currencyDefAwardFunds2: CurrencyDefinition | undefined;

    if(user && user.currencies !== undefined) {
        if(user.currencies !== undefined) {
            currencyDefPrice = user.currencies.find((curDef) => curDef.code === (bundle && bundle.price && bundle.price.currency));

            if(bundle.awardFunds1 && bundle.awardFunds1.currency !== undefined) {
                currencyDefAwardFunds1 = user.currencies.find((curDef) => curDef.code === (bundle.awardFunds1&& bundle.awardFunds1.currency));
            }

            if(bundle.awardFunds2 && bundle.awardFunds2.currency !== undefined) {
                currencyDefAwardFunds2 = user.currencies.find((curDef) => curDef.code === (bundle.awardFunds2&& bundle.awardFunds2.currency));
            }
        }
    }

    if(bundle.awardFunds2&& bundle.awardFunds2.amount&& bundle.awardFunds2.amount) {
        awardFunds2Amount = bundle.awardFunds2.amount.toString();
    }

    if(currencyDefAwardFunds2 && currencyDefAwardFunds2.name) {
        awardFunds2CurrencyName = currencyDefAwardFunds2.name
    }

    if(bundle && bundle.price && bundle.price.amount) {
        if(currencyDefPrice !== undefined) {
            price = CurrencyFormatter.formatWithSymbol(currencyDefPrice, Big(bundle.price.amount))
        }
    }

    let item;
    if(bundle.awardPokerItemList !== undefined) {
        item = bundle.awardPokerItemList.find((item) => item.category !== undefined); // assumes we only have one item or none
    }


    return (
        <div className={"bundle"}>
            <FloatingTitle item={item} bundle={bundle}/>
            <div className={"top"}>
                <div className={"one"}>
                    <img alt={"bundle"} onClick={() => {}} className={"image"} src={bundle.imageUrl && bundle.imageUrl}/>
                </div>
                <div className={"two"}>
                    <div className={"containerTop"}>
                        {
                            currencyDefAwardFunds1&& currencyDefAwardFunds1.prefixSymbol && (
                                <sup className={"currencyAwardFunds1"}>
                                    {
                                        currencyDefAwardFunds1.prefixSymbol
                                    }
                                </sup>
                            )
                        }
                        <span className={"awardFunds1"}>
                            {
                                bundle.awardFunds1&& bundle.awardFunds1.amount&& bundle.awardFunds1.amount
                            }
                        </span>
                        {
                            currencyDefAwardFunds1&& currencyDefAwardFunds1.postfixSymbol&& (
                                <sup className={"currencyAwardFunds1"}>
                                    {
                                        currencyDefAwardFunds1.postfixSymbol
                                    }
                                </sup>
                            )
                        }
                    </div>
                    <div className={"containerBottom"}>
                        <span className={"text"}>
                            {
                                t("store.bundles.price").replace("|amount|", awardFunds2Amount).replace("|cur|", awardFunds2CurrencyName)
                            }
                        </span>
                        <span className={"text2"}>
                            {
                                item&& (
                                    item.category === Category.AVATAR
                                        ? (
                                            item.name&& (
                                                `+ 1 ${item.name} Avatar`
                                            )
                                        )
                                        : null
                                )
                            }
                            {
                                item&& (
                                    item.category === Category.TICKET
                                        ? (
                                            item.name&& (
                                                `+ ${item.name}`
                                            )
                                        )
                                        : null
                                )
                            }
                            {
                                item&& (
                                    item.category === Category.INVENTORY
                                        ? (
                                            item.name&& (
                                                `+ 1 ${item.name}`
                                            )
                                        )
                                        : null
                                )
                            }
                        </span>
                    </div>
                </div>
                <div className={"three"}>
                    <span className={"avatarOrTicket"}>
                        {
                            item&& (
                                <img alt={"avatar or ticket"} onClick={() => {}} className={"maskAndImage"} src={item.imageUrl&& item.imageUrl}/>
                            )
                        }
                    </span>
                </div>
            </div>
            <div className={"bottom"}>
                <Button
                    id={bundle.id}
                    title={`${t("store.bundles.buyNow")} ${price}`}
                    onClick={onClick}
                    enabled={true}/>
            </div>
        </div>
    )
}


export default BundleComponent;

